// extracted by mini-css-extract-plugin
export default {"wrapper":"GameOver_wrapper__uaEk1","title":"GameOver_title__aYvi7","message":"GameOver_message__YXwtI","thanks":"GameOver_thanks__g11si","backButton":"GameOver_backButton__yRaO8"};